import { makeModel } from "./crudModel";
import { currentJobModel as currentJobModels } from "./currentJobModel";

export const currentJobModel = currentJobModels("currentJob");
export const users = makeModel("users");
export const settings = makeModel("settings");

export { default as ecommerce } from "./ecommerceModel";
export { default as sso } from "./ssoModel";
